// extracted by mini-css-extract-plugin
export default {"container":"AssetTypeDropdownSelector_container__DF9kU","title":"AssetTypeDropdownSelector_title__mdnzC"};